import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import CourseDetailContent from "./CourseDetailContent";
import { getMypageCourseApplicant } from "../../../../services/apiCourseApplicant";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import { COURSE_DETAIL } from "../../../../utils/config";

const CourseDetail = () => {
  // 講座ID
  const { id } = useParams();
  // 講座詳細データ
  const [detailData, setDetailData] = useState([]);
  // ローディング表示
  const [loading, setLoading] = useState(false);

  // 講座データ表示
  const returnContent = () => {
    return <CourseDetailContent detailData={detailData} />;
  };

  // ボタン表示
  const returnButton = () => {
    if (!detailData.applicant_id && detailData.in_period) {
      if (detailData.is_disp_applybtn) {
        return (
          <Link
            className="p-course-page__btn-link"
            to={"../applicant/" + detailData.id}
          >
            講座に申し込む
          </Link>
        );
      }
    } else if (detailData.is_cancelable) {
      return (
        <Link
          className="p-course-page__btn-link"
          to={"../cancel/" + detailData.id}
          state={{ prev: COURSE_DETAIL }}
        >
          講座をキャンセルする
        </Link>
      );
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    // ローディング表示開始
    setLoading(true);
    // 講座情報、講座申込情報取得
    (async function () {
      const data = await getMypageCourseApplicant({ id });
      if (data == undefined || !data) return;
      // データが取得できたらローディング表示終了
      setLoading(false);
      setDetailData(data);
    })();
  }, []);

  return (
    <>
      {detailData ? (
        <div className="l-page-right">
          <div className="l-page-con">
            <div className="p-user-link">
              <div className="p-user-link-item">
                <Link
                  to={
                    detailData.applicant_id
                      ? "/mypage/course/applied"
                      : "/mypage/course/search/accepting"
                  }
                >
                  一覧へ戻る
                </Link>
              </div>
              <div className="p-user-link-item">
                <a
                  className="p-user-link01"
                  href={
                    process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN +
                    "/mypage-manual/"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  使い方を見る（新しいウィンドウで開きます）
                </a>
              </div>
            </div>
            {returnContent()}
            <div className="p-course-page__btn">{returnButton()}</div>
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CourseDetail;
